import React from 'react';

type FullBleedSectionProps = React.HTMLAttributes<HTMLElement> & {
  /** Rendered element. Defaults to `section`. */
  as?: 'section' | 'div';
};

// 100vw breakout that escapes the Layout's centred max-width container so a
// background surface reaches the viewport edges. width:100vw includes the
// scrollbar gutter, matching window.innerWidth, and the symmetric negative
// margins re-centre the band. Shared so every store's full-bleed bands use
// one consistent technique instead of duplicating the calc() inline.
const FULL_BLEED_STYLE: React.CSSProperties = {
  width: '100vw',
  marginLeft: 'calc(50% - 50vw)',
  marginRight: 'calc(50% - 50vw)',
};

/**
 * A band that spans the full viewport width regardless of any centred
 * max-width ancestor. Pass `className` for the surface (e.g. `bg-bg-secondary`)
 * and put a normal container inside to re-constrain the content.
 */
const FullBleedSection: React.FC<FullBleedSectionProps> = ({ as = 'section', children, ...rest }) => {
  const Tag = as as React.ElementType;
  // Spread consumer attrs first, then override `style` with the breakout
  // merged over any caller-supplied style. (Reading rest.style rather than
  // destructuring it keeps react/prop-types happy on the generic
  // HTMLAttributes type.)
  return (
    <Tag {...rest} style={{ ...FULL_BLEED_STYLE, ...rest.style }}>
      {children}
    </Tag>
  );
};

export default FullBleedSection;
